var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v("隐私政策")]),_c('div',{staticClass:"main",domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }